import React from "react";

import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import QRCode from "qrcode";

import { sortTickets, formatNumber, formatDateTime, getTimezoneDate, timezones } from "../../utilities/helpers";

import Alert from "react-bootstrap/Alert";
import Stack from "react-bootstrap/Stack";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

import { ActionBtns } from "../ActionBtns";

import scanQR from "../../assets/icons/scan-qr-code.svg";

export default function MyTickets({
    eventObj,
    order,
    guestList,
    handleClick,
    ticketStatus,
}) {
    const tickets = order ? order?.tickets : guestList?.guest_passes;
    const event = order?.event || eventObj;

    const timezone = timezones(event?.venue?.timezone);

    const generatePDF = async (ticket, order) => {
        const pdfDoc = await PDFDocument.create();
        const page = pdfDoc.addPage([400, 200]);

        const { width, height } = page.getSize();
        const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

        // Event details
        const eventName = event?.name;
        let eventDate = getTimezoneDate(event?.start, timezone);
        eventDate = formatDateTime(eventDate)
        const venue = event?.venue?.name;
        let location;
        if (ticket.generalAdmission) {
            location = `General Admission: ${ticket?.sectionNumber}`;
        } else {
            location = `Section ${ticket?.sectionNumber}, Row ${ticket?.rowNumber}, Seat ${ticket?.seatNumber}`;
        }
        console.log("Ticket ", ticket);
        const checkInCode = ticket?.checkInCode;

        // Add text
        page.drawText(eventName, {
            x: 20,
            y: height - 30,
            size: 12,
            font,
            color: rgb(0, 0, 0),
        });

        page.drawText(`Date: ${eventDate}`, {
            x: 20,
            y: height - 50,
            size: 12,
            font,
        });

        page.drawText(`Venue: ${venue}`, {
            x: 20,
            y: height - 70,
            size: 12,
            font,
        });

        page.drawText(`Location: ${location}`, {
            x: 20,
            y: height - 90,
            size: 12,
            font,
        });

        // Generate QR code
        const qrDataUrl = await QRCode.toDataURL(checkInCode);
        const qrImage = await pdfDoc.embedPng(qrDataUrl);
        page.drawImage(qrImage, {
            x: 300,
            y: height - 130,
            width: 80,
            height: 80,
        });

        // Download
        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        window.open(url, "_blank");
    };

    const getTitle = () => {
        let title;
        if (order) {
            title = `${tickets?.length > 1 ? "Tickets" : "Ticket"}`;
        } else if (guestList) {
            title = `Guest ${tickets?.length > 1 ? "passes" : "pass"}`;
        }

        return title;
    };

    return (
        <section>
            <div className="section-heading-md heading--flex">
                <h2>
                    {getTitle()} ({formatNumber(tickets.length)})
                </h2>
                <ActionBtns
                    handleClick={handleClick}
                    ticketStatus={ticketStatus}
                    order={order}
                    eventObj={event}
                />
            </div>
            <Alert variant="info">
                <img src={scanQR} width="44" height="44" alt="" />
                <div>
                    <p className="fw-semi-bold">Your phone is your ticket</p>
                    <p className="caption">
                        Login to blocktickets.xyz on your phone and go to My events and then
                        click Event details.
                    </p>
                </div>
            </Alert>
            <Stack gap={3} className="mt-4">
                {sortTickets(tickets).map((ticket, index) => (
                    <Card body className="card--white" key={index}>
                        <div className="heading--flex">
                            <Card.Title as="h5" className="card-title-sm">
                                {ticket?.generalAdmission ? (
                                    <>{ticket?.sectionNumber}</>
                                ) : (
                                    <Stack direction="horizontal" gap={4}>
                                        <Stack direction="horizontal" gap={2}>
                                            <span className="text-muted normal fw-normal">Sec</span>
                                            <span>{ticket?.sectionNumber}</span>
                                        </Stack>
                                        <Stack direction="horizontal" gap={2}>
                                            <span className="text-muted normal fw-normal">Row</span>
                                            <span>{ticket?.rowNumber}</span>
                                        </Stack>
                                        <Stack direction="horizontal" gap={2}>
                                            <span className="text-muted normal fw-normal">Seat</span>
                                            <span>{ticket?.seatNumber}</span>
                                        </Stack>
                                    </Stack>
                                )}
                            </Card.Title>
                            <Stack direction="horizontal" gap={3}>
                                <Button
                                    onClick={() => handleClick("details", ticket)}
                                    variant="link"
                                >
                                    Details
                                </Button>
                                <Button
                                    size="xs"
                                    className="btn-print btn-print--sm icon-button-xs icon-button--white"
                                    onClick={() => generatePDF(ticket, order)}
                                >
                                    Print
                                </Button>
                            </Stack>
                        </div>
                    </Card>
                ))}
            </Stack>
        </section>
    );
}
